.child_Child_e281eb3{fill:var(--pencil-color)}